import { Box, Grid, useTheme } from "@mui/material";
import { useGoalCategoryLabels } from "web_myplann/Goals/Hooks/useGoalCategoryLabels";
import {
	GOAL_CATEGORY_CONFIG,
	SELECTABLE_GOAL_CATEGORIES,
} from "web_myplann/Goals/Types/GoalTypes";
import type { GoalCategoryTypeEnum } from "web_myplann/Infrastructure/Api/Api";
import { SelectableCardButton } from "web_myplann/Shared/Components/SelectableCardButton";

type Props = {
	value: GoalCategoryTypeEnum | undefined;
	onChange: (next: GoalCategoryTypeEnum | undefined) => void;
	disabled?: boolean;
};

export const GoalCategorySelector = ({ value, onChange, disabled }: Props) => {
	const theme = useTheme();
	const categoryLabels = useGoalCategoryLabels();

	return (
		<Box px={1.6} py={1.2} bgcolor={theme.palette.background.paper}>
			<Grid container spacing={1}>
				{SELECTABLE_GOAL_CATEGORIES.map((category) => {
					const config = GOAL_CATEGORY_CONFIG[category];
					const Icon = config.icon;
					const selected = value === category;

					return (
						<Grid key={category} size={4}>
							<SelectableCardButton
								selected={selected}
								disabled={disabled}
								onClick={() => onChange(selected ? undefined : category)}
								label={categoryLabels[category]}
								icon={
									<Box
										width={32}
										height={32}
										borderRadius={theme.radii.lg}
										bgcolor={config.bgColor}
										display="flex"
										alignItems="center"
										justifyContent="center"
									>
										<Icon size={18} color={config.color} />
									</Box>
								}
							/>
						</Grid>
					);
				})}
			</Grid>
		</Box>
	);
};
